<template>
  <!-- <div class="absolute top-0 left-[5%] right-[12%] flex flex-col items-end" v-click-outside="outsideDiv"> -->
  <div class="absolute top-0 right-[5%] md:right-[12%] flex flex-col items-end">
    <button
      @click="$emit('change')"
      class="px-2 py-1 bg-ontick-steel-500 rounded-bl rounded-br shadow-md text-ontick-blue-500"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        stroke-width="1.5"
        stroke="currentColor"
        class="w-6"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          d="M10.5 6h9.75M10.5 6a1.5 1.5 0 1 1-3 0m3 0a1.5 1.5 0 1 0-3 0M3.75 6H7.5m3 12h9.75m-9.75 0a1.5 1.5 0 0 1-3 0m3 0a1.5 1.5 0 0 0-3 0m-3.75 0H7.5m9-6h3.75m-3.75 0a1.5 1.5 0 0 1-3 0m3 0a1.5 1.5 0 0 0-3 0m-9.75 0h9.75"
        />
      </svg>
    </button>
    <div v-show="status" class="flex p-1.5 mt-1 space-x-1.5 bg-ontick-steel-500 rounded shadow-md -mr-0 md:mr-0">
      <slot></slot>
    </div>
  </div>
</template>

<script>
import ClickOutside from "vue-click-outside";

export default {
  name: "adjustment-chart",
  directives: {
    ClickOutside,
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      status: this.visible,
      // status: true, //[TEMPORÁRIO] deixar a config aberta para trabalho.
    };
  },
  watch: {
    visible: {
      deep: true,
      handler(value) {
        this.status = value;
        return value;
      },
    },
  },
  methods: {
    outsideDiv() {
      this.$emit("click-outside");
    },
  },
};
</script>
